import './style.scss'
import UiModal from '../../../../js/components/UiModal/UiModal'
import { showAlchemerePopup } from '../../../../js/components/Alchemere'
import { showAutopaymentModal } from '../../../popups/v1/AutopayModal/scripts'
import { Slider } from '../../../../js/components/Slider/Slider'
import { Media, SubmitType } from '../../../../js/utils/const'
import Form from '../../../../js/Form/Form'

const MatchMedia = {
  sm: window.matchMedia(`(max-width: ${Media.SM_MAX}px)`),
  lg: window.matchMedia(`(min-width: ${Media.LG}px)`)
}
const indexToHeight = new Map()

class TariffsModal extends UiModal {
  constructor(template, options) {
    super(template, {
      blockTriggerName: options.blockName || 'Блок без названия',
      isIndent: false,
      wrapperClass: 'tariffs-v5-modal',
      outerScroll: true
    })

    this.type = options.type || 'pay'
    this.wrapper = null
    this.headers = null
    this.features = null
    this.isExpanding = false
  }

  mounted() {
    this.wrapper = this.element.querySelector('.tariffs-v5-modal__wrapper')
    this.items = this.element.querySelectorAll('.tariffs-v5__item')
    this.headers = this.element.querySelectorAll('.tariffs-v5__top')
    this.subtitle = this.element.querySelectorAll('.tariffs-v5__subtitle')
    this.features = this.element.querySelectorAll('.tariffs-v5__features')
    this.expandButton = this.element.querySelector('.tariffs-v5__expand-button')

    this.formInit(this.items)
    this.addSubmitListeners(this.items)
    this.sliderInit(this.wrapper, this.items)
    this.tariffsResize(this.wrapper, this.headers, this.features, this.subtitle)
    this.expandButton?.addEventListener('click', this.expandButtonHandler)
  }

  beforeUnmounted() {
    this.removeSubmitListeners(this.items)
    this.expandButton?.removeEventListener('click', this.expandButtonHandler)
  }

  beforeClose() {
    showAlchemerePopup('lead')
  }

  formInit = (items) => {
    items.forEach(item => {
      const data = JSON.parse(item.dataset.tariffData)
      const autopaymentData = data.payments?.find(payment => payment.value === 'cloudpayments')?.autopayment
      const form = item.querySelector('.form')

      new Form({
        form,
        blockName: this.blockTriggerName,
        autopaymentData
      }).init()
    })
  }

  addSubmitListeners = (items) => {
    items.forEach(item => {
      item.querySelector('.form').addEventListener('form-success', this.formSubmitHandler)
    })
  }

  removeSubmitListeners = (items) => {
    items.forEach(item => {
      item.querySelector('.form').removeEventListener('form-success', this.formSubmitHandler)
    })
  }

  sliderInit = (wrapper, items) => {
    const options = {
      wrapper,
      settings: {
        loop: false,
        autoScrollOffset: 1,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        slideClass: 'tariffs-v5__item',
        wrapperClass: 'tariffs-v5__list',
        spaceBetween: 8,
      },
      initCondition: {
        sm: items.length > 1,
        md: items.length > 1,
        lg: false,
        xl: false
      },
      createCallback: (slider) => {
        slider?.slideTo?.(1, 0)
        wrapper.classList.remove('tariffs-v5__content--static')
      },
      destroyCallback: () => {
        wrapper.classList.add('tariffs-v5__content--static')
      }
    }

    const slider = new Slider(options)
    slider.init()
    slider?.slider?.slideTo(1, 0)
  }

  tariffsResize = (wrapper, headers, features, subtitle) => {
    const loopAtFeatures = (lists, callback) => {
      lists.forEach((list) => {
        const items = list.querySelectorAll('.tariffs-v5__feature')
        items.forEach(callback)
      })
    }

    const fillHeightMap = (item, i) => {
      item.removeAttribute('style')
      const height = item.clientHeight

      indexToHeight.set(i, indexToHeight.has(i)
        ? Math.max(indexToHeight.get(i), height)
        : height
      )
    }

    const setItemHeight = (item, i) => {
      item.style.height = indexToHeight.has(i) ? `${indexToHeight.get(i)}px` : 'auto'
    }

    const setHeight = (elements) => {
      const heights = [...elements].map((p) => {
        p.removeAttribute('style')
        return p.clientHeight
      })
      const maxHeight = Math.max(...heights)

      elements.forEach((el) => {
        el.style.height = `${maxHeight}px`
      })
    }
    const updateItemHeight = () => {
      indexToHeight.clear()
      setHeight(headers)
      setHeight(subtitle)
      loopAtFeatures(features, fillHeightMap)
      loopAtFeatures(features, setItemHeight)
    }

    const resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        for (const entry of entries) {
          if (entry.target === wrapper) {
            updateItemHeight()
          }
        }
      })
    })

    resizeObserver.unobserve(wrapper)
    resizeObserver.observe(wrapper)

    updateItemHeight()

    MatchMedia.sm.removeEventListener('change', updateItemHeight)
    MatchMedia.lg.removeEventListener('change', updateItemHeight)
    MatchMedia.sm.addEventListener('change', updateItemHeight)
    MatchMedia.lg.addEventListener('change', updateItemHeight)
  }

  formSubmitHandler = (evt) => {
    const tariff = evt.target.closest('.tariffs-v5__item')

    if (!tariff) {
      return
    }

    const data = JSON.parse(tariff.dataset.tariffData)

    /* eslint-disable-next-line */
    !isGbHost && window.$analytics?.push('fl-show-form')
    window.$analytics?.push('tariff-subscribe-button-click', {
      tariffName: data.name,
      blockName: this.blockTriggerName
    })

    /* eslint-disable-next-line */
    if ((data.isDefault && this.type === SubmitType.CONSULT) && !enabledAutoPaymentForConsult) {
      showAlchemerePopup('order') !== null && this.close()
      return
    }

    if (!data.payments?.length) {
      showAlchemerePopup('order') !== null && this.close()
      return
    }

    const template = document.querySelector('#auto-payment-form')
      ?.content.cloneNode(true).querySelector('.auto-payment-form')

    if (template) {
      showAutopaymentModal(template, {
        nomenclatureId: data.nomenclature_id,
        methods: data.payments,
        type: this.type,
        blockName: this.blockTriggerName
      })
      this.close()
    }
  }

  expandButtonHandler = () => {
    this.isExpanding = !this.isExpanding
    const buttonTextContent = this.expandButton.querySelector('span')

    if (this.isExpanding) {
      this.expandButton.classList.add('tariffs-v5__expand-button--expand')
      buttonTextContent.textContent = 'Скрыть'

      this.features.forEach((item) => {
        item.classList.add('tariffs-v5__features--expanding')
        item.removeAttribute('style')
      })

      this.items.forEach((item) => item.classList.add('tariffs-v5__item--expanding'))
    } else {
      this.expandButton.classList.remove('tariffs-v5__expand-button--expand')
      buttonTextContent.textContent = 'Раскрыть всё'

      this.features.forEach((item) => {
        item.classList.remove('tariffs-v5__features--expanding')
        item.style.height = '292px'
      })

      this.items.forEach((item) => item.classList.remove('tariffs-v5__item--expanding'))
    }

    window.$analytics?.push('tariff-show-more-button-click', { blockName: this.blockTriggerName })
  }
}

export const showTariffsModalGroupB = (template, options) => {
  if (!template) {
    return
  }

  new TariffsModal(template, options).init()
}
